export const createConsentObserver = () => {
  const subscribers = new Map();
  let latestNotification;
  let notificationId = 0;

  const deliver = (token, notification) => {
    const subscriber = subscribers.get(token);
    if (
      !subscriber ||
      notification.notificationId < latestNotification.notificationId ||
      subscriber.lastDeliveredId >= notification.notificationId
    ) {
      return;
    }
    subscriber.lastDeliveredId = notification.notificationId;
    subscriber.callback(notification);
  };

  return {
    listenChangeUserConsent(callback) {
      const token = Symbol('consent callback');
      subscribers.set(token, { callback, lastDeliveredId: 0 });
      if (latestNotification) {
        const notification = latestNotification;
        Promise.resolve().then(() => deliver(token, notification));
      }
      return token;
    },
    stopListeningChangeUserConsent(token) {
      subscribers.delete(token);
    },
    notifyConsentChange(details) {
      latestNotification = Object.freeze({
        ...details,
        purposesConsent: Object.freeze([...details.purposesConsent]),
        vendorsConsent: Object.freeze([...details.vendorsConsent]),
        notificationId: ++notificationId,
      });
      const notification = latestNotification;
      // New subscriptions receive replay, not a second delivery in this loop.
      for (const token of Array.from(subscribers.keys())) {
        deliver(token, notification);
      }
    },
  };
};
